/** Audience values returned by order pricing APIs (PBI #1186). */
export const OrderPricingAudiences = {
  Public: 'public',
  Free: 'free',
  Member: 'member',
} as const;

export type OrderPricingAudience =
  (typeof OrderPricingAudiences)[keyof typeof OrderPricingAudiences];

/**
 * Shown under the list price when the viewer is not on a member plan.
 * Member pricing is re-resolved at charge time, so upgrading before place
 * (or between schedule and placement for mailed cards) unlocks the discount.
 */
export const MEMBER_PRICE_UPGRADE_HINT =
  'Upgrade anytime before you place your order to unlock the member price.';

/**
 * Compact carousel / tile copy when the member tier is fully waived
 * (animated e-cards: 100% Personal-plan discount).
 */
export const FREE_FOR_MEMBERS_LABEL = 'Free for members';

/** Prefix for compact “Members pay $X.XX” carousel callouts. */
export const MEMBERS_PAY_LABEL_PREFIX = 'Members pay';
